import channels from './api/data/channels'

export const getChannels = () => channels

export const getChannelById = id =>
  channels.filter(channel => channel.channel_id === id)
